<template>
    <div class="bi-com bi-input">
        <label class="bi-lbl"
            :for="id">{{label}}</label>
        <div class="bi-wrapper">
            <input type="text"
                :id="id"
                class="bi-ib"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                :maxlength="maxLength"
                v-model="content"
                @input="onChange()" />
            <span class="bi-placeholder"
                :class="{'bi-placeholder-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                v-show="!content">{{placeholder}}</span>
        </div>
        <div class="bi-lbl-error"
            v-if="isShowErrorLbl"
            v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (optional) Validate result
 * @property {boolean} isTextOnly (optional) Only text.
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: 'TextInput',
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        isTextOnly: Boolean,
    },
    data: function () {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0
        };
    },
    mounted: function () {
        this.id = this.inputId;
        this.label = this.inputLbl.name || 'Label';
        this.placeholder = this.inputLbl.placeholder || 'Placeholder';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.minLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid;
                return;
            }
        },
        onChange: function () {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');

            if(this.isTextOnly) {
                result = result.replace(Vue.RegExp.number, '');
                result.replace(Vue.RegExp.symbol, '')
            }

            this.validateInput();
            this.content = result;
            this.$emit('input', result);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";
</style>
